export const isTransmissionWithModelCode = (obj) => !!obj && !!obj.transmissionKey && !!obj.modelCode;
